<template>
  <div class="VideoViewer" @click="toggle(null)">
    <video
      loop
      class="video"
      :src="require(`@/` + videoSrc)"
      playsinline
      autoplay
      muted
    />
  </div>
</template>

<script>
export default {
  props: ['videoSrc', 'toggle'],
};
</script>

<style scoped>
.VideoViewer {
  width: 100%;
  height: 100%;
  padding-top: 1em;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  display: grid;
  place-items: center;
  transform: translateY(100%);
  animation: slide-up 0.35s ease-in-out forwards;
}
.video {
  max-width: 80%;
  border-radius: 10px;
}
@keyframes slide-up {
  to {
    transform: translateY(0%);
  }
}
</style>
